<div mat-dialog-title>{{'Association' | translate}}</div>
<div>
    <ng-container>
        <mat-dialog-content>
            <app-sub-plan-associations [itemType]="data.itemType" [subscriptionPlan]="data.subscriptionPlan" [defaultItem]="data.item"></app-sub-plan-associations>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="btn btn--outline-grey-color mr-20" mat-dialog-close>{{'action.close' | translate}}</button>
        </mat-dialog-actions>
    </ng-container>
</div>
